import { cn } from '@/lib/utils'
import styles from '@/components/assets-explorer/assets-explorer.module.scss'
import { Skeleton } from '@/components/ui/skeleton'
import React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

export const contentsSliderVariants = cva('', {
  variants: {
    aspect: {
      default: 'tw-aspect-ultra-wide',
      square: 'tw-aspect-square',
    },
  },
  defaultVariants: {
    aspect: 'default',
  },
})

export type ContentsSliderSkeletonProps = VariantProps<typeof contentsSliderVariants>

export default function ContentsSliderSkeleton({ aspect }: ContentsSliderSkeletonProps) {
  return (
    <ul
      className={cn(styles.assetGallerySlider, {
        [styles.imageGallery]: aspect === 'square',
      })}
    >
      {Array.from({ length: 3 }).map((_, index) => (
        <li key={index}>
          <Skeleton className={cn(contentsSliderVariants({ aspect }))} />
        </li>
      ))}
    </ul>
  )
}
